<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Doortypes") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'doorType.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <advanced-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
        :filterCols="filterCols"
        :filters="filters"
        v-on:filter="
          filters = $event;
          getData();
        "
        :footer-props="{
          'items-per-page-options': [10, 15, 50, -1]
        }"
      >
        <template v-slot:item.name="{ item }">
          <v-row>
            <v-col cols="1">
              <v-img
                :src="item.icon | addToken"
                height="50"
                contain
                flat
                v-if="item.icon"
              ></v-img>
              <v-img
                src="/img/tmp/default.png"
                height="50"
                contain
                flat
                v-else
              ></v-img>
            </v-col>
            <v-col class="pl-1">
              {{ item.name }}
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.numberranges="{ item }">
          <v-chip
            class="mr-1"
            small
            v-for="(tmp, index) in item.numberranges"
            :key="index"
          >
            {{ tmp }}
          </v-chip>
        </template>
        <template v-slot:item.code="{ item }">
          <span v-if="$auth.user().permissions.includes('doorType.update')"
            ><a target="_blank" :href="'/doortype/' + item.id">{{
              item.code
            }}</a></span
          >
          <span v-else>{{ item.code }}</span>
        </template>
        <template v-slot:item.active="{ item }">
          <v-checkbox
            v-if="item.active"
            input-value="true"
            value
            disabled
          ></v-checkbox>
          <v-checkbox v-else value disabled></v-checkbox>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="duplicateItem(item)">
            mdi-content-duplicate
          </v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></advanced-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import {
  fetchItems,
  deleteItem,
  duplicateItem,
  fetchTypeCategories
} from "../shared/services";
import axios from "axios";
import { persistentTableOptions } from "../../../plugins/mixins";

var cancel;
var CancelToken = axios.CancelToken;

export default {
  name: "app-doorType-list",
  mixins: [persistentTableOptions],
  data() {
    return {
      headers: [
        {
          text: "Code",
          align: "left",
          value: "code"
        },

        {
          text: "Aktiv",
          align: "left",
          value: "active"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Nummernkreise",
          align: "left",
          value: "numberranges",
          sortable: false
        },
        { text: "", value: "action", sortable: false }
      ],
      loading: true,
      options: {
        itemsPerPage: 50
      },
      total: 0,
      search: "",
      items: [],
      filters: [],
      door_type_categories: []
    };
  },
  computed: {
    filterCols() {
      return [
        {
          name: "code",
          type: "text"
        },
        {
          name: "name",
          type: "text"
        },
        {
          title: this.$t("category"),
          name: "door_type_category_id",
          type: "select",
          props: {
            itemText: "name",
            itemValue: "id"
          },
          items: this.door_type_categories
        }
      ];
    }
  },
  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;
      if (cancel != undefined) {
        cancel();
      }

      let response = await fetchItems(
        {
          ...this.options,
          search: this.search,
          filters: this.filters
        },
        new CancelToken(function executor(c) {
          cancel = c;
        })
      );
      this.items = response.data;
      this.total = response.meta.total;
      fetchTypeCategories().then(res => {
        this.door_type_categories = res.data.map(cat => {
          return {
            id: cat.id,
            name: cat.name
          };
        });
      });

      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Doortype?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "doorType.edit", params: { id: url } });
    },
    async duplicateItem(item) {
      let url = item.id;
      let resp = await duplicateItem(item.id);
      if (resp.success) {
        this.$notification(resp.message, { type: "success" });
      } else {
        this.$notification(resp.message, { type: "error" });
      }
      this.getData();
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
